import { Component, OnInit } from '@angular/core';
import { ProfileService } from 'src/app/core/providers';
import { ComponentBase } from '../component.base';

@Component({
  selector: 'app-restricted',
  templateUrl: './restricted.component.html',
  styleUrls: ['./restricted.component.scss'],
  standalone: false,
})
export class RestrictedComponent implements OnInit {
  constructor(public profileService: ProfileService) {}

  getLabelTranslation = (value: string, replacements?: Array<any>) => {
    return this.profileService.getLabelTranslation(value, replacements);
  };

  ngOnInit(): void {}
}
